<div class="modal-header">
  <h4 class="modal-title">Activer une licence</h4>
  <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
  <div class="mb-3">
    <label for="licenceKey" class="form-label">Clé de licence</label>
    <input type="text" class="form-control" id="licenceKey" [(ngModel)]="licenceKey" placeholder="Entrez votre clé de licence">
  </div>
  @if(error){
    <div class="alert alert-danger">{{error}}</div>
  }
  @if(success){
    <div class="alert alert-success">{{success}}</div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Annuler</button>
  <button type="button" class="btn btn-primary" (click)="verifyLicence()">Vérifier</button>
</div> 